// Self-selected management scope; shared by ordinary and learning-task entry.
export const MANAGER_LEVELS = [
  { value: 'S1', role: '骨干 / 班组长', you: '带几个人、管一摊具体活的一线负责人', focus: '把 AI 用进自己的高频管理动作（借力为主）' },
  { value: 'S2', role: '部门经理 / 业务负责人', you: '管一个部门或业务线、对结果负责', focus: '带人机混合团队、用好 AI 主体（带队·共生·治理·借力）' },
  { value: 'S3', role: '高管 / 创始人', you: '管多个部门或整个公司、定方向', focus: '组织级带队治理 + AI 战略判断（带队·治理·共生·谋势）' },
];
